import { APP_NAVIGATION } from './app-navigation.config';

export interface RouteCatalogEntry {
    moduleLabel?: string;
    sectionLabel?: string;
    pageLabel?: string;
    moduleIdentifier: string;
    sectionIdentifier: string;
    pageIdentifier: string;
    routerLink: string;
}

const ADMIN_ROUTE_CATALOG: RouteCatalogEntry[] = [
    {
        moduleLabel: 'Administración',
        sectionLabel: 'Sistema',
        pageLabel: 'Usuarios',
        moduleIdentifier: 'administracion',
        sectionIdentifier: 'sistema',
        pageIdentifier: 'usuarios',
        routerLink: '/admin/usuarios',
    },
    {
        moduleLabel: 'Administración',
        sectionLabel: 'Sistema',
        pageLabel: 'Páginas',
        moduleIdentifier: 'administracion',
        sectionIdentifier: 'sistema',
        pageIdentifier: 'paginas',
        routerLink: '/admin/paginas',
    },
    {
        moduleLabel: 'Administración',
        sectionLabel: 'Sistema',
        pageLabel: 'Roles',
        moduleIdentifier: 'administracion',
        sectionIdentifier: 'sistema',
        pageIdentifier: 'roles',
        routerLink: '/admin/roles',
    },
];

export const ROUTE_CATALOG: RouteCatalogEntry[] = [
    ...APP_NAVIGATION.map((entry) => ({
        moduleLabel: entry.moduleLabel,
        sectionLabel: entry.sectionLabel,
        pageLabel: entry.pageLabel,
        moduleIdentifier: entry.moduleIdentifier,
        sectionIdentifier: entry.sectionIdentifier,
        pageIdentifier: entry.pageIdentifier,
        routerLink: entry.routerLink,
    })),
    ...ADMIN_ROUTE_CATALOG,
];
